import { IS_PRODUCTION } from '@repo/common-utils';
import { useWorkingPlatform } from '@repo/platform';
import { useState } from 'react';

import { getRandomInt } from '@/lib/utils/random';
import { useRemoteConfig } from '@/lib/web/core/use-firebase';

export const useRandomWaitingModal = (remoteConfigKey = 'LANDING_WAITING_TIME') => {
  const { workingPlatform } = useWorkingPlatform();
  const [waitingTime, setWaitingTime] = useState(0);
  const [waitingCallback, setWaitingCallback] = useState<(() => void) | undefined>();
  const waiting = useRemoteConfig(remoteConfigKey)?.[IS_PRODUCTION ? 'prd' : 'dev'];

  const showWaitingModal = () => {
    if (waiting?.isActive && !waiting?.skipPlatforms?.includes(workingPlatform)) {
      const newWaitingTime = getRandomInt(waiting?.minWaitingTime, waiting?.maxWaitingTime);
      setWaitingTime(newWaitingTime);
      return;
    }
    waitingCallback?.();
  };

  return {
    isInitWaitingModalSetting: !!waiting,
    waitingTime,
    setWaitingTime,
    showWaitingModal,
    waitingCallback,
    setWaitingCallback
  };
};
